<template>
  <Teleport to="body">
    <div class="fixed bottom-4 right-4 z-50 space-y-2">
      <TransitionGroup
        enter-active-class="transition ease-out duration-300"
        enter-from-class="opacity-0 translate-y-2 scale-95"
        enter-to-class="opacity-100 translate-y-0 scale-100"
        leave-active-class="transition ease-in duration-200"
        leave-from-class="opacity-100 translate-y-0 scale-100"
        leave-to-class="opacity-0 translate-y-2 scale-95"
        move-class="transition-transform duration-300"
      >
        <div
          v-for="toast in toasts"
          :key="toast.id"
          :class="getToastClasses(toast.type)"
          class="max-w-sm w-full rounded-md shadow-lg border flex items-center p-3"
        >
          <div class="flex-shrink-0">
            <i v-if="toast.type === 'success'" class="pi pi-check-circle text-lg"></i>
            <i v-else-if="toast.type === 'error'" class="pi pi-times-circle text-lg"></i>
            <i v-else-if="toast.type === 'warning'" class="pi pi-exclamation-triangle text-lg"></i>
            <i v-else class="pi pi-info-circle text-lg"></i>
          </div>
          <div class="ml-3 flex-1">
            <p class="text-sm font-medium">
              {{ toast.message }}
            </p>
          </div>
          <div class="ml-4 flex-shrink-0">
            <button
              @click="removeToast(toast.id)"
              class="inline-flex text-current hover:opacity-75 focus:outline-none focus:opacity-75 p-1 rounded"
            >
              <i class="pi pi-times text-sm"></i>
            </button>
          </div>
        </div>
      </TransitionGroup>
    </div>
  </Teleport>
</template>

<script setup lang="ts">
import { useToast } from '@/composables/useToast'

const { toasts, removeToast } = useToast()

const getToastClasses = (type: string) => {
  const variants = {
    success: 'bg-green-50 text-green-800 border-green-200 dark:bg-green-900/20 dark:text-green-400 dark:border-green-800',
    error: 'bg-red-50 text-red-800 border-red-200 dark:bg-red-900/20 dark:text-red-400 dark:border-red-800',
    warning: 'bg-yellow-50 text-yellow-800 border-yellow-200 dark:bg-yellow-900/20 dark:text-yellow-400 dark:border-yellow-800',
    info: 'bg-blue-50 text-blue-800 border-blue-200 dark:bg-blue-900/20 dark:text-blue-400 dark:border-blue-800'
  }
  
  return variants[type as keyof typeof variants] || variants.info
}
</script>